var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.series !== null
    ? _c(
        "div",
        [
          _c(
            "page-header",
            {
              attrs: {
                title:
                  _vm.$t("pages.admin.series.management.title") +
                  ": " +
                  _vm.series.title[_vm.$i18n.locale],
                "icon-class": "mdi mdi-television"
              }
            },
            [
              _c("div", { staticClass: "text-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "cursor-pointer text-primary font-weight-bold",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addVideoModal.open()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "mdi mdi-plus" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.admin.series.management.add_video")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "alert alert-secondary border-dark" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("pages.admin.series.management.explanation")
                    ) +
                    "\n            "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.videos, function(video) {
              return _c(
                "div",
                {
                  key: video.id,
                  staticClass: "col-md-3 stretch-card grid-margin"
                },
                [
                  _c("gym-video-card", {
                    key: video.id,
                    attrs: {
                      video: video,
                      "show-progress": false,
                      "show-like": false,
                      "show-completed": false,
                      "hover-effect-enabled": false
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "card-footer pl-4 pr-4" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger btn-sm",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeVideoFromSeries(
                                            video.id
                                          )
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "mdi mdi-close" })]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "sweet-modal",
            {
              ref: "addVideoModal",
              attrs: {
                width: "80%",
                title: _vm.$t("pages.admin.series.management.add_video")
              },
              on: {
                open: function($event) {
                  _vm.addVideoModalOpened = true
                },
                close: function($event) {
                  _vm.addVideoModalOpened = false
                }
              }
            },
            [
              _vm.addVideoModalOpened
                ? _c("video-selector", {
                    attrs: { "excluded-series-id": _vm.series.id },
                    on: { select: _vm.addVideoToSeries }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }